// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import {
  Radio,
  RadioGroup,
  FormHelperText,
  RadioGroupProps,
  FormControlLabel,
  Stack,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import { IPack } from '../../@types/package';
import Label from 'components/label/Label';
import { fNumber } from 'utils/formatNumber';
import Iconify from 'components/iconify/Iconify';
import { getPackById, setCurrentPack, setOpenDialogForm } from 'redux/slices/package';
import { useSelector } from 'redux/store';
import { setError } from 'redux/slices/global';

// ----------------------------------------------------------------------

type Props = RadioGroupProps & {
  name: string;
  label?: string;
  options: IPack[];
};

export default function RHFPackRadioGroup({ name, label, options, ...other }: Props) {
  const { user } = useSelector((state) => state.global);
  const actions = (user?.permission && user?.permission['orderseeding']) ?? [];
  const { control } = useFormContext();

  const handleEditPack = async (pack: IPack) => {
    const [_, error] = await getPackById(pack.id);
    if (_) {
      setCurrentPack(_);
      setOpenDialogForm(true);
    } else if (error) {
      setError(error.errors);
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field, fieldState: { error } }) => (
        <div>
          <RadioGroup {...field} row {...other}>
            {options.map((option) => (
              <Stack key={option.id} direction="row" alignItems="center" spacing={1}>
                {actions.length > 0 && (
                  <Tooltip title={`Click để sửa gói`}>
                    <IconButton color="primary" onClick={() => handleEditPack(option)}>
                      <Iconify icon="akar-icons:edit" />
                    </IconButton>
                  </Tooltip>
                )}
                <Label
                  sx={{ minWidth: 80 }}
                  component="span"
                  color={option.status == 1 ? 'success' : 'warning'}
                >
                  {option.status === 1 ? 'Hoạt động' : 'Bảo trì'}
                </Label>
                <FormControlLabel
                  value={option.id}
                  control={<Radio disabled={option.status != 1} />}
                  label={
                    <>
                      {actions.length > 0 && (
                        <FormHelperText error>{option.providerName}</FormHelperText>
                      )}
                      <Typography>
                        <Typography component="span" variant="body2">
                          {option.displayname}
                        </Typography>
                        <Typography component="span" color="primary" variant="body2">
                          ({fNumber(option.pricesale)} Coin)
                        </Typography>
                      </Typography>
                    </>
                  }
                />
              </Stack>
            ))}
          </RadioGroup>

          {!!error && (
            <FormHelperText error sx={{ px: 2 }}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}
